
var pause_refresh = false;

function monitor_initiate_events() { 
  jQuery('.add-note').on('shown.bs.collapse', function () {
    pause_refresh = true;
    console.log('Paused it.');
  });
  jQuery('.add-note').on('hidden.bs.collapse', function () {
    pause_refresh = false;
    console.log('UnPaused it.');
  });
  console.log('Initiate events.');

  // Remove events for all forms
  jQuery('.monitor-note-form').off();
  jQuery('.monitor-note-form').on('submit', function (event) {

    jQuery.ajax({
      type: "post",
      dataType: "json",
      url: vars.ajaxurl,
      data: {
        action: "lab_update_note",
        id: jQuery(this).find(".appt_id").val(),
        notes: jQuery(this).find(".appt_note").val()
      },
      success: function (response) {
        // Unpause and refresh.
        pause_refresh = false;

        update_appt_list();

      },
      error: function (errorThrown) {
        jQuery('#msg-result').html('Error! There was an issue sending your message.');
        console.log("ERROR: " + errorThrown);
      }
    });

    // stop the form from submitting the normal way and refreshing the page
    event.preventDefault();


  });

  jQuery('#next-page').off();
  jQuery('#next-page').on('click', function () { 
    var current_offset = jQuery('#offset').val();
    var per_page = jQuery('#per-page').val();
    var new_offset = parseInt(current_offset) + parseInt(per_page);
    jQuery('#offset').val(new_offset);

    update_appt_list();

    return false;
  });

  jQuery('#previous-page').off();
  jQuery('#previous-page').on('click', function () { 
    var current_offset = jQuery('#offset').val();
    var per_page = jQuery('#per-page').val();
    var new_offset = parseInt(current_offset) - parseInt(per_page);
    jQuery('#offset').val(new_offset);

    update_appt_list();

    return false;
  });


  // Register event for marking an appointment as complete
  jQuery('.mark-complete, .mark-incomplete').on('click', function () { 
    var appt_id = jQuery(this).attr('data-appt-id');

    var status = '';

    if (jQuery(this).hasClass('mark-complete')) {
      status = 'complete';
    } else { 
      status = 'scheduled';
    }

    console.log('Trying to mark ' + appt_id + ' as ' + status);

    jQuery.ajax({
      type: "post",
      dataType: "json",
      url: vars.ajaxurl,
      data: {
        action: "lab_update_appt_status",
        id: appt_id,
        status: status
      },
  
      success: function(response) {
        update_appt_list();
      },
      error: function(errorThrown) {
        console.log('ERROR: ' + errorThrown);
      }
    });


    return false;
  });



  jQuery(".popover-info").popover({
    trigger: 'hover'
  });

}

function update_appt_list() { 
  if (pause_refresh) { 
    console.log('Tried to refresh but did not becuase we are paused.');
    return;
  }

    jQuery(".loader").removeClass("hiding");
  setTimeout(function () {
      jQuery(".loader").removeClass("hide");
  }, 10);
  
  var hauler_id = jQuery("#hauler_id").val();
  var interval = jQuery("#interval").val();
  var offset = jQuery("#offset").val();
  var status = jQuery("#status").val();
  var type = jQuery("#type").val();
  var date = jQuery("#datepicker").val();
  var direction = jQuery("#direction").val();

  console.log(date);

  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: vars.ajaxurl,
    data: {
      action: "lab_fetch_appointments_list",
      hauler_id: hauler_id,
      interval: interval,
      status: status,
      offset: offset,
      type: type,
      date: date,
      direction: direction
    },

    success: function(response) {
      if (response) {
        jQuery('#monitor-view').html(response.appt_html);

        setTimeout(function () {
          monitor_initiate_events();
        }, 100);
      }

      setTimeout(function () {
        jQuery(".loader").addClass("hiding");
      }, 10);
      setTimeout(function () {
          jQuery(".loader").addClass("hide");
      }, 20);
    },
    error: function(errorThrown) {
      console.log('ERROR: ' + errorThrown);
    }
  });
}


// Add a note to an appointment and refresh the entire list.
function monitor_add_note() { 

  jQuery(".loader").removeClass("hiding");
  setTimeout(function () {
    jQuery(".loader").removeClass("hide");
  }, 10);


  return;

  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: vars.ajaxurl,
    data: {
      action: "lab_add_note"
    },

    success: function(response) {
      if (response) {
        console.log(response);
        jQuery('#monitor-view').html(response.appt_html);
      }

      setTimeout(function () {
        jQuery(".loader").addClass("hiding");
      }, 10);
      setTimeout(function () {
          jQuery(".loader").addClass("hide");
      }, 20);
    },
    error: function(errorThrown) {
      console.log('ERROR: ' + errorThrown);
    }
  });
}


jQuery(document).ready(function() {
  if (jQuery('#monitor-view').length > 0) { 
    update_appt_list();
    // Continually update the appt list every minute.
    setInterval(function () {
      update_appt_list();
    }, 60000);
  }

  // Update whenever the form changes.
  jQuery('#monitor-filters').on('submit', function (event) {

    update_appt_list();

    // stop the form from submitting the normal way and refreshing the page
    event.preventDefault();

  });

  jQuery("#hauler_id, #interval, #status, #type, #datepicker, #direction").on("change", function () {
    // Move offset to 0
    jQuery('#offset').val("0");
    jQuery('#monitor-filters').submit();
  });

  // On click download the CSV and pass on the arguments
  jQuery('#csv_export').on('click', function () {

    var hauler_id = jQuery("#hauler_id").val();
    var interval = jQuery("#interval").val();
    var offset = jQuery("#offset").val();
    var status = jQuery("#status").val();
    var type = jQuery("#type").val();
    var date = jQuery("#datepicker").val();
    var direction = jQuery("#direction").val();

    var args = '&hauler_id=' + hauler_id;
    args += '&interval=' + interval;
    args += '&offset=' + offset;
    args += '&status=' + status;
    args += '&type=' + type;
    args += '&date=' + date;
    args += '&direction=' + direction;
    var url = '/monitor-view?action=export_appts' + args;

    window.location.href = url;

  });



});



